import React from 'react';

// Renders a two-column "label | value" sheet definition (the same object
// utils/sheetExport.js turns into Excel/PDF), so the preview matches the files.
export default function SheetPreview({ sheet }) {
  const border = `1px solid #${sheet.borderColor || 'A9C29F'}`;
  const cell = { border, padding: '4px 8px' };

  return (
    // Fixed width (not 100%) so the preview's zoom enlarges the sheet in both directions.
    <table className="sheet-preview" style={{ borderCollapse: 'collapse', width: 560 }}>
      <thead>
        <tr>
          <th colSpan={2} style={{ ...cell, background: `#${sheet.headerColor}`, fontSize: 16, textAlign: 'center' }}>
            {sheet.header}
          </th>
        </tr>
      </thead>
      <tbody>
        {sheet.rows.map((r) => (r.section ? (
          <tr key={r.label}>
            <td colSpan={2} style={{ ...cell, background: r.fill ? `#${r.fill}` : undefined, fontWeight: 700, textAlign: 'center' }}>
              {r.label}
            </td>
          </tr>
        ) : (
          <tr key={r.label}>
            <td
              style={{
                ...cell,
                width: '50%',
                fontWeight: sheet.boldLabels ? 700 : 400,
                background: r.labelFill ? `#${r.labelFill}` : undefined,
              }}
            >
              {r.label}
            </td>
            <td style={{ ...cell, textAlign: 'center', background: r.fill ? `#${r.fill}` : undefined }}>{r.text}</td>
          </tr>
        )))}
        {sheet.banner && (
          <tr>
            <td colSpan={2} style={{ ...cell, background: `#${sheet.banner.fill}`, fontWeight: 700, textAlign: 'center' }}>
              {sheet.banner.text}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
